import { useEffect, useState } from 'react'

import { withRouter } from 'i18n/utils'

import featureToggles from 'shared/featureToggles'
import { getAllSurveys, getAnswerSendingResult, sendSurveyAnswerPendingSelector } from 'nps-view/selectors'
import { accountKeySelector, userSelector } from 'auth/selectors'
import { lastReservationSelector } from 'grs/selectors'

import { getReservations } from 'dashboard-transactions/actions'
import { getAllSurveysByCountry, sendSurveyAnswer, clearAnswerSentIndicator } from 'nps-view/actions'

const withNPS = WrappedComponent => props => {
    const {
        allSurveys,
        getAllSurveysByCountry,
        accountKey,
        sendSurveyAnswer,
        isAnswerSentSuccessfuly,
        pending,
        clearAnswerSentIndicator,
        reservation,
        getReservations,
        user,
    } = props
    const [isModalOpen, setModalOpen] = useState(false)
    const checkNpsSurveyData = user && featureToggles.showNpsSurvey

    const showNpsSurvey = () => {
        const currentDate = new Date()
        const createdDate = new Date(reservation.createdDateISO)
        const diffTime = Math.abs(currentDate - createdDate)

        const diffMonths = diffTime / (1000 * 60 * 60 * 24 * 30)

        const isSurveyAvailable =
            typeof allSurveys !== 'string' && Object.keys(allSurveys).length > 0 && !isAnswerSentSuccessfuly

        if (diffMonths < 12) {
            if (isSurveyAvailable) {
                setModalOpen(true)
            } else {
                setModalOpen(false)
            }
        } else {
            setModalOpen(false)
        }
    }

    useEffect(() => {
        clearAnswerSentIndicator()
    }, [])

    useEffect(() => {
        checkNpsSurveyData && getReservations(0, 1, true)
    }, [user?.id])

    useEffect(() => {
        checkNpsSurveyData && accountKey && getAllSurveysByCountry()
    }, [accountKey])

    useEffect(() => {
        checkNpsSurveyData && reservation && showNpsSurvey()
    }, [reservation])

    const onSkip = () => {
        sendSurveyAnswer(null, null)
        setModalOpen(false)
    }

    const onSubmit = (rating, ratingText) => sendSurveyAnswer(rating, ratingText)

    const onModalClose = () => setModalOpen(false)

    return (
        <WrappedComponent
            isModalOpen={isModalOpen}
            onModalClose={onModalClose}
            onSubmit={onSubmit}
            onSkip={onSkip}
            pending={pending}
            showThankYouModal={isAnswerSentSuccessfuly}
            surveyData={allSurveys}
            {...props}
        />
    )
}

export default WrappedComponent =>
    compose(
        withRouter,
        connect(
            createStructuredSelector({
                allSurveys: getAllSurveys,
                accountKey: accountKeySelector,
                isAnswerSentSuccessfuly: getAnswerSendingResult,
                pending: sendSurveyAnswerPendingSelector,
                reservation: lastReservationSelector,
                user: userSelector,
            }),
            {
                getAllSurveysByCountry,
                sendSurveyAnswer,
                clearAnswerSentIndicator,
                getReservations,
            }
        )
    )(withNPS(WrappedComponent))
